// BANNER
export const TITLE = <div>Technical Sales Training</div>;
export const SUB_TITLE = "Learn how to deliver effective Dynatrace demos, calculate licensing requirements, troubleshoot common issues, and collaborate with your Dynatrace counterparts on PoC's and PoV's.";
export const TRAINING_TYPE = "TECHNICAL_SALES";

// INSTRUCTIONS
const step1: {step: String,title: String,subTitle: String} = {step: "STEP 1", title: "Register", subTitle: "Register for an upcoming Technical Sales Training."}
const step2: {step: String,title: String,subTitle: String} = {step: "STEP 2", title: "Attend", subTitle: "Attend the training in full and complete all labs and quizzes."}
const step3: {step: String,title: String,subTitle: String} = {step: "STEP 3", title: "Take", subTitle: " Take and pass your Technical Sales quiz."}
export const ALL_STEPS: {step: String,title: String,subTitle: String}[] = [step1, step2, step3];

//CALENDAR
export const CALENDAR_SUB_TITLE = "Check the following schedule to register and join the upcoming live sessions for Technical" +
                                    " Sales Training on your most convenient time.";

// Requirements
export const TITLE_NOTES_1 = "Requirements"
export const BODY_NOTES_1 = <div className="ml-2 mt-3">
                                ·&nbsp;&nbsp; This training is for technical resources that want to acquire skills and knowledge that can be used during PoCs and PoVs.
                                <br></br>
                                <br></br>
                                ·&nbsp;&nbsp; An active Sales Specialist badge is required to register for this training.
                                <br></br>
                                <br></br>
                                ·&nbsp;&nbsp; An active Associate Certification is required to register for this training.
                                <br></br>
                                <br></br>
                                ·&nbsp;&nbsp; Requires an up-to-date browser.
                            </div>;


// Certifications & Achievements
export const TITLE_NOTES = "Certifications & Achievements"
export const BODY_NOTES = <div className="ml-2 mt-3">
                                ·&nbsp;&nbsp; Upon completion of this training, you will be ready to take and pass the Technical Sales quiz.
                                <br></br>
                                <br></br>
                                ·&nbsp;&nbsp; Getting your Technical Sales badge will allow you to:
                                <br></br>
                                &nbsp;&nbsp;·&nbsp;&nbsp; Validate your Dynatrace knowledge to peers, customers, and competitors.
                                <br></br>
                                &nbsp;&nbsp;·&nbsp;&nbsp; Become highly effective in the pre-sales cycle and help close more and bigger deals.
                                <br></br>
                                &nbsp;&nbsp;·&nbsp;&nbsp; Know which resources are available to you and how you can collaborate with your Dynatrace counterparts.
                                <br></br>
                                <br></br>
                                ·&nbsp;&nbsp; Dynatrace Partner Sales Engineer badge remains valid for 2 years and can be renewed.
                            </div>;


// FAQs
export const TITLE_ONE = "Access the Demo environment";
export const TITLE_TWO = "Webinars";

export const SUB_TITLE_ONE = <div>Access the <a target="_blank" href="https://demo.live.dynatrace.com/">Demo environment</a>, where you can practice your skills</div>;
export const SUB_TITLE_TWO = <div>Get in touch with our experts to get most out of the Dynatrace software intelligence platform: <a target="_blank" href="https://www.dynatrace.com/news/webinar/">Dynatrace webinars.</a></div>;

// --



